import type { Transaction } from "../get-transaction";

export function getMethod({
	maskedPan,
	isRefund,
}: Pick<Transaction, "maskedPan"> & {
	isRefund?: boolean;
}) {
	return `${isRefund ? "Refund" : "Sale"} ${maskedPan?.replace("…", "••• ")}`;
}
